import { createContext } from 'react'
const channelProfileContext = createContext()
export default channelProfileContext